import { MSSPriceSectionId } from '@ace-clublabs/common-membership-api-types';
import { useGlobalState } from '../../../../state/state';
import { ManageMembershipPriceCartItem } from '../ManageMembershipPriceCartItem';
import { getMembershipTitle } from '../../../../utils/stringHelper';
import { getIsInMidterm } from '../../../../utils/ruleHelper';

export const BenefitLevelPriceCartItem = () => {
  const [memberDetails] = useGlobalState('memberDetails');
  const [formData] = useGlobalState('formData');
  const [priceCart] = useGlobalState('priceCart');
  const isInMidterm = getIsInMidterm(memberDetails);

  const benefitLevelPrice = priceCart?.items?.find((m) => m.id === MSSPriceSectionId.SERVICE_LEVEL_COST);
  const memberName = benefitLevelPrice?.description?.split('-')[0]?.trim();
  const memberRole = benefitLevelPrice?.description?.split('-')[1]?.trim();
  const price = benefitLevelPrice?.price;
  const benefitLevelTitle = getMembershipTitle(memberDetails, formData.requestedMembershipLevel, undefined, formData);

  return benefitLevelPrice ? (
    isInMidterm ? (
      <ManageMembershipPriceCartItem
        type="description"
        className="benefit-level-price-item"
        description={<>{benefitLevelTitle} member</>}
        price={price}
      />
    ) : (
      <ManageMembershipPriceCartItem
        type="list"
        className="benefit-level-price-item"
        title={<>{benefitLevelTitle} member</>}
        price={price}
        list={[
          {
            name: memberName || '',
            subtext: memberRole,
            price: 'Included',
          },
        ]}
      />
    )
  ) : (
    <></>
  );
};
